import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505] px-4 text-zinc-100">
      <div className="noise-overlay" aria-hidden="true" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md rounded-2xl border border-[#22222A] bg-[#101014] p-10 text-center shadow-[0_24px_80px_rgba(0,0,0,0.6)]"
      >
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#E50914]/10">
          <XCircle className="h-9 w-9 text-[#E50914]" />
        </div>
        <h1 className="mt-6 font-display text-2xl font-bold" data-testid="payment-cancel-title">
          Pagamento cancelado
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-zinc-400">
          Nenhum valor foi cobrado. Você pode tentar de novo quando quiser — ou chamar o Luiz no WhatsApp.
        </p>
        <div className="mt-8 flex flex-col gap-3">
          <a
            data-testid="payment-cancel-back"
            href="/conta"
            className="btn-red-glow inline-flex items-center justify-center rounded-full bg-[#E50914] px-8 py-3.5 font-mono-code text-xs font-bold uppercase tracking-widest text-white"
          >
            Voltar para minha conta
          </a>
          <a href="/" className="text-xs text-zinc-500 transition-colors hover:text-[#E50914]">
            Voltar ao site
          </a>
        </div>
      </motion.div>
    </div>
  );
}
